// import

import type {GetStaticPaths, GetStaticProps} from 'next';

import {revalidate} from 'libs/constants';
import db, {compactNode} from 'libs/db';
import type {PostNode, BlogMainNode} from 'libs/model';
import {PostPage} from 'modules/Post';

// types

type Props = {
  main: BlogMainNode;
  post: PostNode;
  related: PostNode[];
};

type Query = {
  slug: string;
};

// component

export default function PostView(props: Props) {
  const {main, post, related} = props;

  return (
    <PostPage
      cta={post.meta.ctaRef}
      main={main}
      post={post}
      related={related}
    />
  );
}

// data

export const getStaticPaths: GetStaticPaths<Query> =
  async () => {
    return {
      fallback: 'blocking',
      paths: (await db.readPosts())
        .map(({meta: {slug}}) => ({params: {slug}})),
    };
  };

export const getStaticProps: GetStaticProps<Props, Query> =
  async ({preview, params}) => {
    const [main, post, related] = await Promise.all([
      db.readBlogMain({preview}),
      db.readPost(params?.slug as string, {preview}),
      db.readRelatedPosts(12, params?.slug as string, {preview}),
    ]);

    if (!main || !post) {
      return {
        revalidate,
        redirect: {
          permanent: false,
          destination: '/blog',
        },
      };
    }

    return {
      revalidate,
      props: {
        main,
        post,
        related: related
          .filter((n) => n.meta.bannerImage)
          .slice(0, 8)
          .map(compactNode),
      },
    };
  };
